import { mapActions } from "vuex"

export default {
  async created() {
    if (!navigator.onLine) {
      this.online = false
    }
    window.addEventListener("offline", () => {
      this.online = false
    })
    window.addEventListener("online", async () => {
      this.online = true
      this.showOnline = true

      setTimeout(() => (this.showOnline = false), 3000)
    })
  },
}
